//State
import moment from "moment";
import axios from "axios";

export var ModerateState = {
  resolve_status: "",
  account: [],
  accountbyPartner: [],
  location: [],
  locationbyPartner: [],
  locationbyBestPartner: [],
  locationbyWorstPartner: [],
  locationpaginated: [],
  pagesbyPartner: [],
  pages: [],
  reviews: [],
  reviewspages: [],
  // reviews: {},
  conversations: [],
  status_moderate: "",
  success_bu: "",
  success_noreplycount: "",
  location_gmbaccounts: [],
  setting_account: [],
  gbareviews: [],
  AnswerData: [],
  businessUnit: [],
  noreplycount: 0,
  noreplycountbu: 0,
  noreplycountpages: 0,
  reviewscount: [],
  reviewslast3days: [],
  reviewscounttotal: [],
  reviewDetail: [],
  // ANCHOR 10 Best Rating Location
  tenBestRatingLocations: [],
  // ANCHOR 10 Worst Rating Location
  tenWorstRatingLocations: [],
  // ANCHOR Table Green And Red Marming
  tableGreenRedMarkData: [],
};

// Getter
export var ModerateGetter = {
  // functions to obtain state information      ( Getters will receive the state as their 1st argument )
  getResolve: (state) => state.resolve_status,
  getaccount: (state) => state.account,
  getaccountbyPartner: (state) => state.accountbyPartner,
  getlocation: (state) => state.location,
  getlocationbyPartner: (state) => state.locationbyPartner,
  getlocationbyBestPartner: (state) => state.locationbyBestPartner,
  getlocationbyWorstPartner: (state) => state.locationbyWorstPartner,
  getlocationpaginated: (state) => state.locationpaginated,
  getpagesbyPartner: (state) => state.pagesbyPartner,
  getpages: (state) => state.pages,
  getReviews: (state) => state.reviews,
  getReviewCountTotal: (state) => state.reviewscounttotal,
  getReviewsCount: (state) => state.reviewscount,
  getReviewslast3days: (state) => state.reviewslast3days,
  getReviewsPages: (state) => state.reviewspages,
  getReview: (state) => state.review,
  getreviewDelete: (state) => state.review,

  getGbaReviews: (state) => state.gbareviews,
  getconversation: (state) => state.conversations,
  // getLocationGMBAccounts: state => state.location_gmbaccounts,
  getSettingAccount: (state) => state.setting_account,
  getLocationGMBAccounts: (state) => state.location_gmbaccounts,
  getAnswerData: (state) => state.AnswerData,
  getbusinessUnitbyPartner: (state) => state.businessUnit,
  getReviewsBusinessUnit: (state) => state.reviews,
  getnoreplycount: (state) => state.noreplycount,
  getnoreplycountbu: (state) => state.noreplycountbu,
  getnoreplycountpages: (state) => state.noreplycountpages,
  getReviewDetail: (state) => state.reviewDetail,

  // ANCHOR 10 Best Rating Location
  getTenBestRatingLocations: (state) => state.tenBestRatingLocations,
  // ANCHOR 10 Worst Rating Location
  getTenWorstRatingLocations: (state) => state.tenWorstRatingLocations,
  // ANCHOR Table Green Red Marking Data
  getTableGreenRedMarkData: (state) => state.tableGreenRedMarkData,
};

//Actions
const uid = localStorage.getItem("uid");
const pass = localStorage.getItem("pass");

export var ModerateActions = {
  async getSettingAccount({ commit }) {
    commit("modrate_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.account', 'search_read', [], [
              "id",
              "name",
              "access_token_valid",
              "f_access_token_valid",
              "fs_access_token_valid",
              "url_to_get_token",
              "f_url_to_get_token",
              "fs_url_to_get_token",
              "t_url_to_get_token",
              "t_access_token_valid",
            ],
            0,
            0,
            ""
        ]
      }
    };

    await this._vm.$http
      .post("jsonrpc", req_data)
      .then((res) => {
        var getSerringAccount_data = res.data.result;
        var getSerringAccount = [];
        if (getSerringAccount_data.length > 0) {
          getSerringAccount = getSerringAccount_data;
        }

        commit("moderate_Setting_success", getSerringAccount);
        return res;
      })
      .catch((err) => {
        commit("moderate_error");
        return err;
      });
  },
  async getbusinessUnitbyPartner({ commit }, partner_ids) {
    commit("modrate_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'brand_whisper.business_unit', 'search_read', [["partner_id", "in", partner_ids]], [
              "id",
              "name",
              "city",
              "review_count",
              "score",
              "trustpilot_url",
              "address",
              "zip_code",
              "score",
              "web",
              "display_name",
              "api_name",
              "api_id",
              "review_url",
              "phone",
              "description",
              "partner_id",
              "country_code",
              "score",
            ],
            0,
            0,
            ""
        ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("res.data in account::", res.data.result);
        var getbusinessUnit_data = res.data.result;
        var getbusinessUnit = [];
        if (getbusinessUnit_data.length > 0) {
          getbusinessUnit = getbusinessUnit_data;
        }
        commit("moderate_bu_success", getbusinessUnit);
        return res;
      })
      .catch((err) => {
        commit("moderate_error");
        return err;
      });
  },
  async getnoreplycount({ commit }, payload) {
    commit("modrate_request");
    var {
      partner_ids,
      // location_id
    } = payload;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', [
            ["partner_id", "in", partner_ids],
            ["reviewReply", "=", false],
          ]
        , ["location_id"], ["location_id"], 0,0,'',false ]

      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        // //console.log("res.data in noreplycount::", res.data.result[0].__count, res.data.result['length']);
        var noreplycount = [];
        if (res.data.result.length > 0) noreplycount = res.data.result;

        //console.log(noreplycount ,res, " ########### noreplycount");

        commit("moderate_noreplycount_success", noreplycount);
        return res;
      })
      .catch((err) => {
        commit("moderate_error");
        return err;
      });
  },
  async getnoreplycountbu({ commit }, payload) {
    commit("modrate_request");
    // //console.log("in get getnoreplycount");
    var { partner_ids, business_unit_id } = payload;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', [
            ["partner_id", "in", partner_ids],
            ["reviewReply", "=", false],
          ]
        , ["business_unit_id"], ["business_unit_id"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("res.data in noreplycount::", res.data.result);
        var noreplycount = [];
        if (res.data.result.length > 0) noreplycount = res.data.result;

        commit("moderate_noreplycountbu_success", noreplycount);
        return res;
      })
      .catch((err) => {
        commit("moderate_error");
        return err;
      });
  },
  async getnoreplycountpages({ commit }, payload) {
    commit("modrate_request");
    var { partner_ids, page_id } = payload;
    ////console.log("in get getnoreplycount");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
          service: 'object',
          method: 'execute',

          args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', [
            ["partner_id", "in", partner_ids],
            ["reviewReply", "=", false],
          ]
          , ["page_id"], ["page_id"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("res.data in noreplycount::", res.data.result);
        var noreplycount = [];
        if (res.data.result.length > 0) noreplycount = res.data.result;

        commit("moderate_noreplycountpage_success", noreplycount);
        return res;
      })
      .catch((err) => {
        commit("moderate_error");
        return err;
      });
  },

  async getReviewCountTotal({ commit }, payload) {
    commit("modrate_request");
    // //console.log("in get getnoreplycount");
    var { partner_ids, type, id } = payload;
    var curr_date = moment()
      .utc()
      .subtract(3, "d")
      .format("YYYY-MM-DD");

    var domain = []; //["comment_eng","!=", false]

    if (partner_ids.length > 0) {
      domain.push(["partner_id", "in", partner_ids]);
    }
    if (type == "location") {
      domain.push(["location_id", "=", id]);
    }
    if (type == "business_unit") {
      domain.push(["business_unit_id", "=", id]);
    }
    if (type == "page") {
      domain.push(["page_id", "=", id]);
    }
    if (type == "partner3days") {
      domain.push(["createTime", ">", curr_date]);
    }
    // console.log("partner_ids in total:: ", partner_ids, id);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
          service: 'object',
          method: 'execute',
          args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', domain, [], ["reviewReply"], 0,0,'',false ]
       },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var reviewscount = [];
        if (res.data.result.length > 0) {
          reviewscount = res.data.result;
        }
        //console.log("111111 res.data in reviewscount::", reviewscount);

        // noreplycount= res.data.result;

        commit("moderate_reviewscounttotal_success", reviewscount);
        return res;
      })
      .catch((err) => {
        commit("moderate_error");
        return err;
      });
  },
  async getlocationpaginated({ commit }, payload) {
    commit("modrate_request");
    var { partner_ids, offset } = payload;
    //console.log("getlocationpaginated payload",payload);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        context: user_context.user_context, //{ "uid":8, "lang":"es_ES" },
        model: "brand_whisper.location",
        domain: [["partner_id", "=", partner_ids]],
        fields: [
          "city",
          "locationName",
          "description",
          "maps_url",
          "zip_code",
          "api_ID",
          "primaryPhone",
          "websiteUrl",
          "address",
          "zip_code",
          "averageRating",
          "totalReviewCount",
          "partner_id",
        ],
        sort: "",
        limit: 80,
        offset: offset,
      },
    };

    await this._vm.$http
      .post("/web/dataset/search_read", req_data)
      .then((res) => {
        console.log("res.datain getlocationpaginated", res.data.result);
        var getlocation = res.data.result;
        //////console.log('res data from. geolocation...=>', res);
        commit("moderate_getlocationpaginated_success", getlocation);
        return res;
      })
      .catch((err) => {
        //////console.log("error in get location:: ", err);
        commit("moderate_error");
        return err;
      });
  },
  async getlocationbyPartner({ commit }, partner_ids) {
    commit("modrate_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'search_read', [["partner_id", "in", partner_ids]], [        
          "id",
          "city",
          "locationName",
          "description",
          "maps_url",
          "zip_code",
          "api_ID",
          "primaryPhone",
          "websiteUrl",
          "address",
          "zip_code",
          "averageRating",
          "totalReviewCount",
          "partner_id",
          "averageRating",
          "regionCode",
          'comunidad_autonoma',
        ], 0, 500, '' ]
      },
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data location by partner:::", res.data.result);
        var getlocation = res.data.result;
        ////console.log('res data from. geolocation...=>', res);
        commit("moderate_getlocationbyPartner_success", getlocation);
        return res;
      })
      .catch((err) => {
        //////console.log("error in get location:: ", err);
        commit("moderate_error");
        return err;
      });
  },
  // ANCHOR Action Location By Best Partner
  async getlocationbyBestPartner({ commit }, payload) {
    let domain = [];
    domain.push(["averageRating", "!=", 0]);
    let sort = "";
    let limit = 10;

    var {
      partner_ids,
      location_ids,
      create_date,
      scoreTags,
      starRatings,
    } = payload;

    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["partner_id", "=", partner_ids]);
      } else {
        domain.push(["id", "in", location_ids]);
      }
    } else {
      domain.push(["partner_id", "in", partner_ids]);
    }

    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_create_time", ">=", `${create_date[0]}`]);
      domain.push(["review_create_time", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      domain.push(["review_star_rating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_score_tag", "in", scoreTags]);
    }

    if (payload.sort) {
      sort = payload.sort;
    }
    if (payload.limit) {
      limit = payload.limit;
    }

    commit("modrate_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'search_read', domain, [
              "id",
              "city",
              "locationName",
              "location_description",
              "description",
              "maps_url",
              "zip_code",
              "api_ID",
              "primaryPhone",
              "websiteUrl",
              "address",
              "zip_code",
              "averageRating",
              "totalReviewCount",
              "partner_id",
              "averageRating",
              "regionCode",
            ],
            0,
            limit,
            sort
        ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data location by partner:::", res.data.result);
        var getlocation = res.data.result;
        ////console.log('res data from. geolocation...=>', res);
        commit("moderate_getlocationbyBestPartner_success", getlocation);
        return res;
      })
      .catch((err) => {
        //////console.log("error in get location:: ", err);
        commit("moderate_error");
        return err;
      });
  },
  // ANCHOR Action Location By Worst Partner
  async getlocationbyWorstPartner({ commit }, payload) {
    let domain = [];
    domain.push(["averageRating", "!=", 0]);

    let sort = "averageRating asc";
    let limit = 10;

    var {
      partner_ids,
      location_ids,
      create_date,
      scoreTags,
      starRatings,
    } = payload;

    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["partner_id", "=", partner_ids]);
      } else {
        domain.push(["id", "in", location_ids]);
      }
    } else {
      domain.push(["partner_id", "in", partner_ids]);
    }

    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_create_time", ">=", `${create_date[0]}`]);
      domain.push(["review_create_time", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      domain.push(["review_star_rating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_score_tag", "in", scoreTags]);
    }

    if (payload.sort) {
      sort = payload.sort;
    }
    if (payload.limit) {
      limit = payload.limit;
    }

    commit("modrate_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'search_read', domain, [
              "id",
              "city",
              "locationName",
              "location_description",
              "description",
              "maps_url",
              "zip_code",
              "api_ID",
              "primaryPhone",
              "websiteUrl",
              "address",
              "zip_code",
              "averageRating",
              "totalReviewCount",
              "partner_id",
              "averageRating",
              "regionCode",
            ],
            0,
            limit,
            sort
        ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data location by partner:::", res.data.result);
        var getlocation = res.data.result;
        ////console.log('res data from. geolocation...=>', res);
        commit("moderate_getlocationbyWorstPartner_success", getlocation);
        return res;
      })
      .catch((err) => {
        //////console.log("error in get location:: ", err);
        commit("moderate_error");
        return err;
      });
  },
  async getpagesbyPartner({ commit }, partner_ids) {
    //////console.log('get_pages', commit);
    commit("modrate_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.page', 'search_read', [["partner_id", "in", partner_ids]], [
             "id",
              "name",
              "totalReviewCount",
              "category",
              "averageRating",
              "partner_id",
              "review_ids",
              "averageRating",
            ],
            0,
            0,
            ""
        ]
      },
    };

    await this._vm.$http
      // .get("/apache/rest_api/brand_whisper.page", {
      //     headers: {
      //         //"X-Odoo-dbfilter": "apachev1",
      //         fields:
      //             '["id","name","totalReviewCount","category", "averageRating", ("partner_id", ["id", "name"]),  ["review_ids", ["id", "comment", "reviewReply"]] ]'
      //     },

      //     params: {
      //         limit: 0,
      //         args:`[["partner_id.id", "in", [${partner_ids}]]]`
      //     }
      // })
      .post("/jsonrpc", req_data)
      .then((res) => {
        var get_pages = res.data.result;
        commit("moderate_pagesbypartner_success", get_pages);
        return res;
      })
      .catch((err) => {
        commit("moderate_error");
        return err;
      });
  },
  async getReviews({ commit }, payload) {
    commit("modrate_request");
    var sortBy = "createTime desc";
    // var {
    //     location_id,
    //     // offset
    // }=payload;
    var {
      location_id,
      createTime,
      starRating,
      scoreTag,
      reviewReply_type,
      offset,
    } = payload;

    var domain = [["location_id", "=", location_id]];
    if (createTime != "") {
      domain.push(["createTime", ">=", createTime[0]]);
      domain.push(["createTime", "<=", createTime[1]]);
    }
    if (scoreTag != "") {
      domain.push(["score_tag", "=", scoreTag]);
    }
    if (starRating != "") {
      domain.push(["starRating", "=", starRating]);
    }
    if (reviewReply_type != "") {
      if (reviewReply_type === "noreviewReply")
        domain.push(["reviewReply", "=", false]);
      if (reviewReply_type === "reviewReply")
        domain.push(["reviewReply", "!=", false]);
    }
    //console.log("payload in review :::: ", payload, domain);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'search_read', domain, [
              "id",
              "reviewer_name",
              "url_reviewer_photo",
              "comment_eng",
              "comment",
              "createTime",
              "reviewReply",
              "starRating",
              "score_tag",
              "reply_updateTime",
              "location_id",
              "location_city",
              "location_address",
              "location_maps_url",
              "resolved"
            ],
            offset,
            20,
            "createTime desc"
        ]
      },
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data reviews::::", res.data);
        var getReviews = [];
        if (res.data.result.length > 0) {
          // getReviews = res.data.result;
          let mutateReviews = [];
          res.data.result.forEach((item, i) => {
            mutateReviews = [
              ...mutateReviews,
              {
                ...item,
                translateToggle: false,
              },
            ];
          });
          res.data.result = mutateReviews;
          getReviews = res.data.result;

          //console.log("res if reviews :: ", res.data, getReviews, mutateReviews);
        } else {
          getReviews = [];
          ////console.log("res else ::: ", res.data);
        }

        // getReviews.sort(function (a, b) {
        //     var b_date = new Date(b.createTime).getTime();
        //     var a_date = new Date(a.createTime).getTime();
        //     var c = b_date - a_date;
        //     return c;
        // });
        commit("moderate_reviews_success", getReviews);
        return res;
      })
      .catch((err) => {
        //////console.log("res.data error reviews::::", err);
        commit("moderate_error");
        return err;
      });
  },
  async getReviewsBusinessUnit({ commit }, payload) {
    commit("modrate_request");
    var sortBy = "createTime desc";

    var {
      business_unit_id,
      createTime,
      starRating,
      scoreTag,
      offset,
      reviewReply_type,
    } = payload;

    var domain = [["business_unit_id", "=", business_unit_id]];
    if (createTime != "") {
      domain.push(["createTime", ">=", createTime]);
      domain.push(["createTime", "<=", createTime]);
    }
    if (scoreTag != "") {
      domain.push(["score_tag", "=", scoreTag]);
    }
    if (starRating != "") {
      domain.push(["starRating", "=", starRating]);
    }
    if (reviewReply_type != "") {
      if (reviewReply_type === "noreviewReply")
        domain.push(["reviewReply", "=", false]);
      if (reviewReply_type === "reviewReply")
        domain.push(["reviewReply", "!=", false]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        context: user_context.user_context, //{ "uid":8, "lang":"es_ES" },
        model: "brand_whisper.review",
        domain: domain, // (To get location reviews)
        fields: [
          "id",
          "reviewer_name",
          "url_reviewer_photo",
          "business_unit_id",
          "comment_eng",
          "comment",
          "createTime",
          "reviewReply",
          "starRating",
          "score_tag",
          "reply_updateTime",
          "location_id",
          "location_city",
          "business_unit_description",
          "business_unit_city",
        ],
        sort: "createTime desc",
        limit: 20,
        offset: offset,
      },
    };
    await this._vm.$http
      .post("/web/dataset/search_read", req_data)
      .then((res) => {
        ////console.log("res.data reviews::::", res.data);
        var getReviews = [];
        if (res.data.result.length > 0) {
          let mutateReviews = [];
          res.data.result.forEach((item, i) => {
            mutateReviews = [
              ...mutateReviews,
              {
                ...item,
                translateToggle: false,
              },
            ];
          });
          res.data.result = mutateReviews;
          getReviews = res.data.result;
          // getReviews = res.data.result;
          // console.log("info-", getReviews);
          ////console.log("res if businessUnit:: ", res.data);
        } else {
          getReviews = [];
          ////console.log("res else ::: ", res.data);
        }

        // getReviews.sort(function (a, b) {
        //     var b_date = new Date(b.createTime).getTime();
        //     var a_date = new Date(a.createTime).getTime();
        //     var c = b_date - a_date;
        //     return c;
        // });
        commit("moderate_reviews_success", getReviews);
        return res;
      })
      .catch((err) => {
        //////console.log("res.data error reviews::::", err);
        commit("moderate_error");
        return err;
      });
  },

  async getReviewslast3days({ commit }, payload) {
    commit("modrate_request");
    var sortBy = "createTime desc";
    var curr_date = moment()
      .utc()
      .subtract(3, "d")
      .format("YYYY-MM-DD");
    var {
      partner_ids,
      createTime,
      starRating,
      scoreTag,
      offset,
      reviewReply_type,
    } = payload;

    var domain = [
      ["partner_id", "in", partner_ids],
      ["createTime", ">", curr_date],
      "|",
      "|",
      ["location_id", "!=", false ],
      ["page_id", "!=", false ],
      ["business_unit_id", "!=", false ],
    ]; //,["comment","!=", false]
    if (createTime != "") {
      domain.push(["createTime", "=", createTime]);
    }
    if (scoreTag != "") {
      domain.push(["score_tag", "=", scoreTag]);
    }
    if (starRating != "") {
      domain.push(["starRating", "=", starRating]);
    }
    if (reviewReply_type != "") {
      if (reviewReply_type === "noreviewReply")
        domain.push(["reviewReply", "=", false]);
      if (reviewReply_type === "reviewReply")
        domain.push(["reviewReply", "!=", false]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'search_read', domain, [
              "id",
              "reviewer_name",
              "url_reviewer_photo",
              "comment_eng",
              "comment",
              "createTime",
              "reviewReply",
              "starRating",
              "score_tag",
              "reply_updateTime",
              "location_id",
              "location_city",
              "location_address",
              "location_maps_url",
              "partner_id",
            ],
            offset,
            20,
            "createTime desc"
        ]
      },
    };

    // //console.log("curr_date ::: ", curr_date);
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("res.data reviews::::", res.data);
        var getReviews = [];
        if (res.data.result.length > 0) {
          getReviews = res.data.result;
          //console.log("res if11111 :: ", res.data.result.length);
        } else {
          getReviews = [];
          ////console.log("res else ::: ", res.data);
        }

        // getReviews.sort(function (a, b) {
        //     var b_date = new Date(b.createTime).getTime();
        //     var a_date = new Date(a.createTime).getTime();
        //     var c = b_date - a_date;
        //     return c;
        // });
        commit("moderate_reviewslast3days_success", getReviews);
        return res;
      })
      .catch((err) => {
        //////console.log("res.data error reviews::::", err);
        commit("moderate_error");
        return err;
      });
  },

  async getReviewslast3daysCount({ commit }, partner_id) {
    commit("modrate_request");
    var sortBy = "createTime desc";
    var curr_date = moment()
      .utc()
      .subtract(3, "d")
      .format("YYYY-MM-DD");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'search_read', [["partner_id", "in", partner_id],["createTime", ">", curr_date],["reviewReply", "=", false]], 
            ["reviewReply", "starRating", "score_tag"],
            0,
            0,
            "createTime desc"
        ]
      },
    };

    // //console.log("curr_date ::: ", curr_date);
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("res.data reviews::::", res.data);
        var getReviews = [];
        if (res.data.result.length > 0) {
          // let mutateReviews = [];
          // res.data.result.forEach((item, i) => {
          //   mutateReviews = [
          //     ...mutateReviews,
          //     {
          //       ...item,
          //       translateToggle: false,
          //     },
          //   ];
          // });
          // res.data.result = mutateReviews;
          // getReviews = res.data.result;
          getReviews = res.data.result;
          // console.log("res if11111 :: ", res.data.result);
        } else {
          getReviews = [];
          ////console.log("res else ::: ", res.data);
        }

        // getReviews.sort(function (a, b) {
        //     var b_date = new Date(b.createTime).getTime();
        //     var a_date = new Date(a.createTime).getTime();
        //     var c = b_date - a_date;
        //     return c;
        // });
        commit("moderate_reviews_count_success", getReviews);
        return res;
      })
      .catch((err) => {
        //////console.log("res.data error reviews::::", err);
        commit("moderate_error");
        return err;
      });
  },

  async getReviewsPages({ commit }, payload) {
    commit("modrate_request");

    var {
      page_id,
      createTime,
      starRating,
      scoreTag,
      offset,
      reviewReply_type,
    } = payload;

    var domain = [["page_id", "=", page_id]];
    if (createTime != "") {
      domain.push(["createTime", ">=", createTime]);
      domain.push(["createTime", "<=", createTime]);
    }
    if (scoreTag != "") {
      domain.push(["score_tag", "=", scoreTag]);
    }
    if (starRating != "") {
      domain.push(["starRating", "=", starRating]);
    }

    if (reviewReply_type != "") {
      if (reviewReply_type === "noreviewReply")
        domain.push(["reviewReply", "=", false]);
      if (reviewReply_type === "reviewReply")
        domain.push(["reviewReply", "!=", false]);
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        context: user_context.user_context, //{ "uid":8, "lang":"es_ES" },
        model: "brand_whisper.review",
        domain: domain, // (To get location reviews)
        fields: [
          "id",
          "reviewer_name",
          "url_reviewer_photo",
          "comment_eng",
          "comment",
          "createTime",
          "reviewReply",
          "starRating",
          "score_tag",
          "reply_updateTime",
          "location_id",
        ],
        sort: "create_date desc",
        limit: 20,
        offset: offset,
      },
    };
    await this._vm.$http
      .post("/web/dataset/search_read", req_data)
      .then((res) => {
        ////console.log("res.data reviews pages::::", res.data.result);
        var getReviews = res.data.result;
        commit("moderate_page_reviews_success", getReviews);
        return res;
      })
      .catch((err) => {
        //////console.log("res.data error reviews::::", err);
        commit("moderate_error");
        return err;
      });
  },

  async getReviewDetail({ commit }, payload) {
    commit("modrate_request");

    // var {
    //     page_id,
    //     createTime,
    //     starRating,
    //     scoreTag,
    //     offset
    // } = payload;
    var { item_id } = payload;

    var domain = [];
    // if(createTime !=""){
    //     domain.push(["createTime", ">=", createTime])
    //     domain.push(["createTime", "<=", createTime])
    // }
    // if(scoreTag !=""){
    //     domain.push(["score_tag", "=", scoreTag])
    // }
    // if(starRating !=""){
    //     domain.push(["starRating", "=", starRating])
    // }

    if (item_id != "") {
      domain.push(["id", "=", item_id]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: { context: user_context.user_context },
        model: "brand_whisper.review",
        args: [item_id, []], //(First list with record IDs, second list with fields, if you send second empty list you will get all fields.)
        method: "read",
      },
    };
    await this._vm.$http
      .post("/web/dataset/call_kw/read", req_data)
      .then((res) => {
        //console.log("res.data reviews detail::::", res.data.result);
        var reviewDetail = res.data.result;
        commit("moderate_reviewDetail_success", reviewDetail);
        return res;
      })
      .catch((err) => {
        //////console.log("res.data error reviews::::", err);
        commit("moderate_error");
        return err;
      });
  },
  async resolveChanged({commit,state},payload){
    commit("modrate_request");
    var {review_id} = payload;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        args:[[review_id],{"resolved":true}],
        method: "write",
        model: "brand_whisper.review",
        kwargs: {}
      },
    };
    await this._vm.$http.post("/web/dataset/call_kw/write",req_data).then((res)=> {
      if(res.status == 200) {
        console.log("HE LLEGADO HASTA AQUI")
        commit("moderate_resolve",res);
        return res;
      } else {
        commit("moderate_error")
      }
    }).catch((err)=>{
      commit("moderate_error")
      return err;
    })
  },
  async scoreChange({commit,state},payload){
    commit("modrate_request");
    var {review_id,cambio} = payload;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: /*{
        args: [[review_id],{"score_tag": scoreChanged}],
        method: "write",
        model: "brand_whisper.review",
        kwargs: {} 
      }*/ {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, "brand_whisper.review", 'write', review_id, cambio]
      },
    };
    await this._vm.$http.post("jsonrpc",req_data).then((res)=> {
      if(res.status == 200) {
        console.log("HE LLEGADO HASTA AQUI")
        commit("moderate_resolve",res);
        return res;
      } else {
        commit("moderate_error")
      }
    }).catch((err)=>{
      commit("moderate_error")
      return err;
    })
  },
  async reviewReplyWizard({ commit, state }, payload) {
    commit("modrate_request");
    var { review_id, reply_text } = payload;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'send_reply', [review_id], reply_text]
      },
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //////console.log("check res in replywizard", res);
        if (res.status == 200) {
          commit("moderate_reviewreply_success", res);
          return res;
        } else {
          commit("moderate_error");
        }
      })
      .catch((err) => {
        //////console.log("err",err);
        commit("moderate_error");
        return err;
      });
  },
  async getreviewDelete({ commit, state }, review_id) {
    commit("modrate_request");
    var reviewid = review_id;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'delete_reply', [review_id]]
      },
    };

    //////console.log("review_id in getreviewDelete :::: ", review_id);
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //////console.log("check res in replywizard delete", res);
        if (res.status == 200) {
          commit("moderate_reviewreply_success", res);
          return res;
        } else {
          commit("moderate_error");
        }
      })
      .catch((err) => {
        //////console.log("err",err);
        commit("moderate_error");
        return err;
      });
  },
  // ANCHOR Action Location By Best Partner
  async getTenBestRatingLocations({ commit }, payload) {
    let domain = [["location_rating", "!=", 0]];
    // domain.push(["partner_id", "in", payload.partner_ids]);
    let sort = "";
    let limit = 10;
    if (payload.sort) {
      sort = payload.sort;
    }
    if (payload.limit) {
      limit = payload.limit;
    }
    commit("modrate_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.topic', 'read_group', domain
        , ["category_id", "review_star_rating_avg", "location_rating"], ["location_id", "category_id"], 0,limit,"location_rating desc",false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data location by partner:::", res.data.result);
        var getlocation = res.data.result;
        ////console.log('res data from. geolocation...=>', res);
        commit("moderate_getTenBestRatingLocations_success", getlocation);
        return res;
      })
      .catch((err) => {
        //////console.log("error in get location:: ", err);
        commit("moderate_error");
        return err;
      });
  },
  // ANCHOR Action Location By Worst Partner
  async getTenWorstRatingLocations({ commit }, payload) {
    let domain = [["location_rating", "!=", 0]];
    // domain.push(["partner_id", "in", payload.partner_ids]);
    let sort = "";
    let limit = 10;
    if (payload.sort) {
      sort = payload.sort;
    }
    if (payload.limit) {
      limit = payload.limit;
    }
    commit("modrate_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.topic', 'read_group', domain
        , ["category_id", "review_star_rating_avg", "location_rating"], ["location_id", "category_id"], 0,limit,"location_rating asc",false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data location by partner:::", res.data.result);
        var getlocation = res.data.result;
        ////console.log('res data from. geolocation...=>', res);
        commit("moderate_getTenWorstRatingLocations_success", getlocation);
        return res;
      })
      .catch((err) => {
        //////console.log("error in get location:: ", err);
        commit("moderate_error");
        return err;
      });
  },
  // ANCHOR Table Freen Red Marking Data
  async getTableGreenRedMarkData({ commit }, payload) {
    let domain = [["location_id", "!=", false]];
    // domain.push(["partner_id", "in", payload.partner_ids]);
    let sort = "";
    let limit = 10;

    var {
      partner_ids,
      location_ids,
      create_date,
      scoreTags,
      starRatings,
    } = payload;
    if (payload.sort) {
      sort = payload.sort;
    }
    if (payload.limit) {
      limit = payload.limit;
    }
    if (location_ids.length > 0) {
      if (location_ids[0] === partner_ids[0]) {
        domain.push(["partner_id", "=", partner_ids]);
      } else {
        domain.push(["location_id", "in", location_ids]);
      }
    } else {
      domain.push(["partner_id", "in", partner_ids]);
    }

    if (create_date.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_create_time", ">=", `${create_date[0]}`]);
      domain.push(["review_create_time", "<=", `${create_date[1]}`]);
    }
    if (starRatings.length > 0) {
      domain.push(["review_star_rating", "in", starRatings]);
    }
    if (scoreTags.length > 0) {
      // rating = ',["starRating","in",['+`${starRatings}`+']]'
      domain.push(["review_score_tag", "in", scoreTags]);
    }

    commit("modrate_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.topic', 'read_group', domain
        , [
            "category_id",
            "review_star_rating_avg",
            "location_review_count",
          ], ["location_id", "category_id"], 0,0,'',false]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data location by partner:::", res.data.result);
        var getlocation = res.data.result;
        ////console.log('res data from. geolocation...=>', res);
        commit("moderate_getTableGreenRedMarkData_success", getlocation);
        return res;
      })
      .catch((err) => {
        //////console.log("error in get location:: ", err);
        commit("moderate_error");
        return err;
      });
  },
};

//mutations
export var ModerateMutations = {

  modrate_request(state) {
    state.status_moderate = "loading";
  },
  moderate_success(state, payload) {
    //////console.log("state moderate :::: ", state);
    //////console.log("payload ::::: ", payload);
    state.status_moderate = "success";
    const accounts = payload;
    state.account = accounts;
  },
  account_moderate_success(state, payload) {
    //////console.log("state moderate :::: ", state);
    //////console.log("payload ::::: ", payload);
    state.status_moderate_account = "success";
    const accounts = payload;
    state.accountbyPartner = accounts;
  },
  moderate_Setting_success(state, payload) {
    //////console.log("state moderate_Setting_success :::: ", state);
    //////console.log("payload ::::: ", payload);
    state.status_moderate = "success";
    const setting_a = payload;
    state.setting_account.push(setting_a);
  },
  moderate_getlocation_success(state, payload) {
    state.status_moderate = "success";
    const location = payload;
    // state.location.push(location);
    state.location = location;
  },
  moderate_getlocationpaginated_success(state, payload) {
    state.status_moderate = "success";
    const location = payload;
    // state.location.push(location);
    state.locationpaginated = location;
  },
  moderate_getlocationbyPartner_success(state, payload) {
    state.status_moderate = "success";
    const location = payload;
    // state.location.push(location);
    state.locationbyPartner = location;
  },
  moderate_getlocation_gmbaccounts_success(state, payload) {
    state.status_moderate = "success";
    const location_gmbaccounts = payload;
    state.location_gmbaccounts.push(location_gmbaccounts);
  },
  moderate_pages_success(state, payload) {
    state.status_moderate = "success";
    const page = payload;
    state.pages = page;
  },
  moderate_pagesbypartner_success(state, payload) {
    state.status_moderate = "success";
    const page = payload;
    state.pagesbyPartner = page;
  },
  moderate_gbareviews_success(state, payload) {
    state.status_moderate = "success";
    const review = payload;
    // state.reviews.push(review);
    state.gbareviews = review;
  },
  moderate_reviews_success(state, payload) {
    state.status_moderate = "success";
    const review = payload;
    // state.reviews.push(review);
    state.reviews = review;
  },
  moderate_reviewslast3days_success(state, payload) {
    state.status_moderate = "success";
    const review = payload;
    // state.reviews.push(review);
    state.reviewslast3days = review;
  },
  moderate_reviews_count_success(state, payload) {
    state.status_moderate = "success";
    const review = payload;
    // state.reviews.push(review);
    state.reviewscount = review;
  },
  moderate_page_reviews_success(state, payload) {
    state.status_moderate = "success";
    const review = payload;
    // state.reviews.push(review);
    state.reviewspages = review;
  },
  moderate_conversation_success(state, payload) {
    state.status_moderate = "success";
    const chat = payload;
    state.conversations.push(chat);
  },
  moderate_reviewreply_success(state, payload) {
    state.status_moderate = "success";
    // const chat = payload;
    // state.conversations.push(chat);
  },
  moderate_resolve(state, payload) {
    state.status_moderate = "success"
    const status_res = payload
    state.resolve_status = status_res
  },
  moderate_error(state) {
    state.status_moderate = "error";
  },
  moderate_AnswerData_success(state, payload) {
    state.AnswerData = "success";
    const answerData = payload;
    // state.reviews.push(review);
    state.AnswerData = answerData;
  },
  moderate_bu_success(state, payload) {
    state.success_bu = "success";
    const businessUnit = payload;
    state.businessUnit = businessUnit;
  },
  moderate_noreplycount_success(state, payload) {
    state.success_noreplycount = "success";
    const noreply_count = payload;
    ////console.log(noreply_count , " :::::::::: noreplycount");
    state.noreplycount = noreply_count;
  },
  moderate_noreplycountbu_success(state, payload) {
    state.success_noreplycount = "success";
    const noreplycount = payload;
    state.noreplycountbu = noreplycount;
  },
  moderate_reviewscounttotal_success(state, payload) {
    state.success_noreplycount = "success";
    const reviewscounttotal = payload;
    state.reviewscounttotal = reviewscounttotal;
  },
  moderate_reviewDetail_success(state, payload) {
    state.success_noreplycount = "success";
    const reviewDetail = payload;
    state.reviewDetail = reviewDetail;
  },
  moderate_noreplycountpage_success(state, payload) {
    state.success_noreplycount = "success";
    const noreplycount = payload;
    state.noreplycountpages = noreplycount;
  },
  // ANCHOR Mutation Location By Best Partner
  moderate_getlocationbyBestPartner_success(state, payload) {
    // state.success_noreplycount = "success";
    let data = [];
    if (payload) {
      data = payload;
    }
    state.locationbyBestPartner = data;
  },
  // ANCHOR Location By Worst Partner
  moderate_getlocationbyWorstPartner_success(state, payload) {
    let data = [];
    if (payload) {
      data = payload;
    }
    state.locationbyWorstPartner = data;
  },
  // ANCHOR Top 10 best rating location
  moderate_getTenBestRatingLocations_success(state, payload) {
    // state.success_noreplycount = "success";
    let data = [];
    if (payload) {
      data = payload;
    }
    state.tenBestRatingLocations = data;
  },
  // ANCHOR Top 10 worst rating location
  moderate_getTenWorstRatingLocations_success(state, payload) {
    // state.success_noreplycount = "success";
    let data = [];
    if (payload) {
      data = payload;
    }
    state.tenWorstRatingLocations = data;
  },
  // ANCHOR Table Green Red Mark Data
  moderate_getTableGreenRedMarkData_success(state, payload) {
    // state.success_noreplycount = "success";
    let data = [];
    if (payload) {
      data = payload;
    }
    state.tableGreenRedMarkData = data;
  },
};
